export enum BottomSheetReturnType {
    SUBMIT = "SUBMIT",
    CANCEL = "CANCEL",
    SECONDARY = "SECONDARY"
}
